// components/locale-sync.tsx
// Sincroniza las preferencias de idioma del usuario con i18next

import { useEffect, useRef } from "react";
import { useQuery } from "convex/react";
import { api } from "@/convex/_generated/api";
import { useLocale } from "@/hooks/useLocale";

/**
 * Componente que sincroniza las preferencias de idioma del usuario
 * desde la base de datos con i18next al cargar la aplicación.
 * 
 * Debe colocarse en un nivel alto del árbol de componentes (ej: __root.tsx)
 * para que se ejecute cuando el usuario inicie sesión.
 */
export function LocaleSync() {
  const currentUser = useQuery(api.system.users.queries.getCurrentUser);
  const { changeLocale, locale } = useLocale();
  const hasInitialized = useRef(false);

  useEffect(() => {
    // Solo sincronizar una vez cuando se carga el usuario
    if (!currentUser || hasInitialized.current) {
      return;
    }

    // Si el usuario tiene preferencias de idioma guardadas
    const userLanguage = currentUser.localePreferences?.language;
    
    if (userLanguage && userLanguage !== locale) {
      console.log(`[LocaleSync] Sincronizando idioma del usuario: ${userLanguage}`);
      changeLocale(userLanguage as "es" | "en");
      hasInitialized.current = true;
    } else if (userLanguage === locale) {
      // El idioma ya está sincronizado
      hasInitialized.current = true;
    }
  }, [currentUser, locale, changeLocale]);

  // Este componente no renderiza nada
  return null;
}
